import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TyreTracksFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.5 6.14V9.24L15.34 7.52V4.42L19.5 6.14ZM10.06 6.98L13.94 4.68V7.86L10.06 10.16V6.98ZM8.66 7.2V10.3L4.5 8.58V5.48L8.66 7.2ZM19.5 10.74V13.84L15.34 12.12V9.02L19.5 10.74ZM10.06 11.54L13.94 9.24V12.42L10.06 14.72V11.54ZM8.66 11.8V14.9L4.5 13.18V10.08L8.66 11.8ZM19.5 15.34V18.44L15.34 16.72V13.62L19.5 15.34ZM10.06 16.1L13.94 13.8V16.98L10.06 19.28V16.1ZM8.66 16.4V19.5L4.5 17.78V14.68L8.66 16.4Z" />
    </SvgIcon>
  );
});
